$(function() {
  $(document).on('click', '.js-copy', function () {
    var $this = $(this)
    var $message = $this.next()
    $message.animate({ opacity: 0 }, 10)
    var $element = $('#' + $this.data('element'))
    navigator.clipboard.writeText($element.text()).then(() => {
      $message.text('Copied!')
      $message.animate({ opacity: 1 }, 10)
    }, () => {
      $message.text('Failed!')
      $message.animate({ opacity: 1 }, 10)
    });
  })
});
